import script from "./DocumentPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentPage.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentPage.vue?vue&type=style&index=0&id=db96ea08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db96ea08"]])

export default __exports__